import { values } from 'lodash'

import { createOptionsFromEnum } from '../utils/createOptionsFromEnum'

export const ROLES = {
  ADMIN: 'ADMIN',
  CORPS_CHIEF: 'CORPS_CHIEF',
  DUTY_OFFICER: 'DUTY_OFFICER',
  INTERNSHIP_DIRECTOR: 'INTERNSHIP_DIRECTOR',
  BASIC_USER: 'BASIC_USER',
  MOUNTAIN_OFFICER: 'MOUNTAIN_OFFICER',
  SUPER_ADMIN: 'SUPER_ADMIN',
  UNIT_COMMANDER: 'UNIT_COMMANDER',
}

export const ROLES_FORM = {
  ADMIN: 'ADMIN',
  CORPS_CHIEF: 'CORPS_CHIEF',
  DUTY_OFFICER: 'DUTY_OFFICER',
  BASIC_USER: 'BASIC_USER',
  MOUNTAIN_OFFICER: 'MOUNTAIN_OFFICER',
  SUPER_ADMIN: 'SUPER_ADMIN',
  UNIT_COMMANDER: 'UNIT_COMMANDER',
}

export const BOOL = {
  NO: false,
  YES: true,
}

export const ROLES_BO_FACM = [
  ROLES.MOUNTAIN_OFFICER, ROLES.CORPS_CHIEF,
  ROLES.DUTY_OFFICER, ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.UNIT_COMMANDER,
]
export const ROLES_ARRAY = values(ROLES)
export const ROLES_FACM_SUBMITTERS = ROLES_ARRAY
export const ROLES_BO_EVAL = [ROLES.INTERNSHIP_DIRECTOR]
export const ROLES_USER_CREATORS = [ROLES.ADMIN, ROLES.SUPER_ADMIN]
export const EVERYONE = 'EVERYONE'

export const ROLES_OPTIONS_ARRAY = values(ROLES_FORM)
export const ROLE_OPTIONS = createOptionsFromEnum({ values: ROLES_OPTIONS_ARRAY, prefix: 'role' })

export const BOOL_OPTIONS = createOptionsFromEnum({ values: values(BOOL), prefix: 'bool' })
